import { i13nConf } from '../../../conf/i13nConf'
import { SHIP_TYPE_ERROR } from './proposalTypes'
import { LISTINGS_LIMIT } from './batchProposals'

/* 常數表 */
export const SITE_NAME = 'supplier_portal'
export const FETCH_STATUS = { INIT: 'INIT', LOADING: 'LOADING', DONE: 'DONE', FAILED: 'FAILED' }

export const SUCCESS = 'success'
export const ERROR = 'error'
export const WARNING = 'warning'
export const INFO = 'info'

export const ANT_UPLOAD_STATUS = {
  UPLOADING: 'uploading',
  ERROR: 'error',
  DONE: 'done'
}

export const API_ERROR_CODE = {
  GENERAL_ERROR: '80000000',
  INVALID_LISTING_ID: '40009127',
  INVALID_PROPOSAL_ID: '40409000',
  NO_PERMISSION: '40304001'
}

export const DEFAULT_NO_FOUND_DESCRIPTION = '目前沒有資料'

export const FRONT_END_DEFINED_ERROR_CODE = {
  FE_LISTING_NOT_FOUND: '80000001',
  FE_BATCH_LISTINGS_OVER_LIMIT: '80000002',
  FE_PROPOSAL_NOT_FOUND: '80000003',
  FE_BATCH_PROPOSALS_OVER_LIMIT: '80000004',
  FE_IMG_EXCEED_LIMIT: '80000005'
}

export const FRONT_END_DEFINED_ERROR_MAPPING = {
  [FRONT_END_DEFINED_ERROR_CODE.FE_LISTING_NOT_FOUND]: '查無賣場編號',
  [FRONT_END_DEFINED_ERROR_CODE.FE_BATCH_LISTINGS_OVER_LIMIT]: `批次修改賣場超過 ${LISTINGS_LIMIT} 筆`,
  [FRONT_END_DEFINED_ERROR_CODE.FE_PROPOSAL_NOT_FOUND]: '查無提案編號',
  [FRONT_END_DEFINED_ERROR_CODE.FE_BATCH_PROPOSALS_OVER_LIMIT]: `批次檢視提案超過 ${LISTINGS_LIMIT} 筆`,
  [FRONT_END_DEFINED_ERROR_CODE.FE_IMG_EXCEED_LIMIT]: '圖片檔案大小超過限制'
}

// https://git.vzbuilders.com/TW-Shopping-BackOffice/component_shopping_supplier_portal_webapp/blob/master/src/main/resources/error.conf
export const API_ERROR_MAPPING = {
  // input validation
  0: '欄位輸入驗證失敗',
  // general error
  [API_ERROR_CODE.GENERAL_ERROR]: '很抱歉，系統忙碌中，請稍後再試', // from apiUtil
  40000001: 'Wrong timestamp format',
  40000002: 'Missing period',
  40000003: 'Wrong fields collection',
  40000005: '內容含有不合法字元',
  40000024: '欄位驗證錯誤', // Constraint violation validate error

  // unauthorized
  40100000: '無效 OAuth2 金鑰', // Invalid OAuth2 token
  40100001: '驗證失敗，請重新登入', // Missing or bad authentication
  40100002: '無效的Cookie，請重新登入', // Invalid cookie
  40100003: 'Simulated login but has no okta cookie', // Simulated login but has no okta cookie
  40100004: '登入逾時，請重新登入', // Check wssid failed
  40100005: '請重新登入', // Issue wssid failed
  40100006: 'Cookie失效，請重新登入', // Cookie has expired

  // forbidden
  40304001: '您無存取權限', // No permission

  // internal server error
  50000000: 'Internal server error', // Query midas comments failed
  50000001: 'Internal server error', // Create midas comment failed
  50000002: 'Internal server error', // Deactivate midas comment failed
  50000003: 'Internal server error', // Get midas comment failed
  50000005: 'Internal server error', // Query Sale DB failed
  50000006: 'Internal server error', // Uncaught exception
  50000007: 'Internal server error', // Convert object to JSON format failed
  50000010: 'Internal server error', // Get cms eps scheduling module failed
  50000020: 'Internal server error', // Request privilege eps failed
  50000021: 'Internal server error', // Request pigeon server failed
  50000022: 'Internal server error', // Request Structured Data API failed
  50000023: 'Internal server error', // Request CMS Category API failed
  50000024: 'Internal server error', // Request Sherpa API failed
  50000025: 'Internal server error', // Request privilege eps failed (Query Privilege DB failed)
  50000026: 'Internal server error', // Request EPS failed (Query Sale DB failed)
  50000027: 'Internal server error', // Request EPS failed (Query Scm DB failed)
  50000028: 'Internal server error', // Request EPS failed (Resize image failed)
  50000029: 'Internal server error', // Request EPS failed (Access AWS S3 failed)
  50000030: 'Internal server error', // Request Product EPS failed (Internal server error)
  50000032: 'Internal server error', // Request EPS failed (Request Resource API failed)
  50000033: 'Internal server error', // Failed to query shp_etl_summary (Internal server error)
  50000034: 'Internal server error', // Request EPS failed (Query Monday DB failed)
  50000035: 'Internal server error', // Request EPS failed (Request BackOffice Vespa failed)
  50000100: 'Internal server error', // Convert id/name failed
  50004000: 'Internal server error', // Get privileged pages failed
  50005000: 'Internal server error', // Query activities failed
  50006000: 'Internal server error', // Query stats failed
  50006001: 'Internal server error', // Get product bundle failed
  50007000: 'Internal server error', // Query inventories failed
  50008000: 'Internal server error', // Query demographics failed
  50009000: 'Internal server error', // Request Product EPS failed (Generate proposal copy HTML failed)
  50009001: 'Internal server error', // Request Product EPS failed (Handle proposal content failed)
  50009002: 'Internal server error', // Request Product EPS failed (Access proposal copies template failed)

  // category error
  40001000: 'Missing parent id', // All category ids provided must be at the same level
  40301000: 'Login user has no permission to access this category',

  // promotion error
  40003000: 'Mismatch promotion id',

  // user error
  40404000: 'User not found',
  40404001: 'Privilege not found',

  [API_ERROR_CODE.INVALID_PROPOSAL_ID]: '無法存取該提案編號', // Proposal not found
  40900001: '無法存取該提案編號', // Create resource by PUT method is unsupported

  // stats
  40000004: 'Invalid stats period', // Invalid stats period
  40000006: 'Period not for a whole month', // Period not for a whole month
  40000008: 'Mismatch term', // Mismatch term

  // inventories
  40007002: 'Get unsalable items but the threshold was not provided',

  // dashboard
  40000023: '日期區間超過限制', // Exceed the period limitation
  40000027: '此賣場無法建立折價券', // The listing cannot create coupons
  40000028: '折抵方式無效', // Invalid discount rule,
  40006000: '已滿 12 則追蹤小卡', //  Over track listing size
  40006001: '賣場已有追蹤小卡', // Duplicate track listing
  40009127: '查無此賣場', //  Invalid listing ID
  40011001: '賣場編號不存在', // Listing ID does not exist
  40406000: '追蹤賣場不存在', //  Track listing not found
  40900002: '折價券發送中', // Coupon is being created
  42900002: '同一天內同一賣場折價券只能發送一次', // The same listing cannot create more than one coupon in one day
  42900003: '此賣場已發送過折價券，有效期限至', // Coupons cannot be created for the same listing before the previous one expires

  // proposal
  // translation refer to https://docs.google.com/document/d/137CcW1k1iXLn8g5FEVQs1xVH4wp_AnwE5o5o5f3isPc/edit
  40000010: '超過一個以上欄位錯誤，請修正後再送出', // Multiple bad parameters
  40000011: '非法的日期格式', // Invalid ISO-8601 format
  40000012: '無法取得圖片檔案', // Image could not be fetched
  40000015: '非法的陣列大小', // Invalid array size
  40000018: '非預期空白欄位', // Unexpected empty field
  40000019: '內容不能包含 emoji 表情符號', // Cannot contains emoji
  40000020: '內容開頭與結尾不能為空白', // Cannot start/end with space
  40009000: '您提報之賣場毛利率過低，請調整售價及成本', // The gross profit margin is too low
  40009001: '賣場毛利率需大於0/等於0', // The gross profit margin should be greater than or equal to 0
  40009002: '您無權申請低毛利率賣場', // No permission to apply for low gross profit margin listing
  40009003: '您無權設定賣場顯示', // No permission to set listing is not display
  40009005: '該子站不存在', // Sub station not exist
  40009006: '當配送方式為直店配時，市價不可超過NT$20,000', // MSRP cannot be greater than CVS' limitation NT$20,000
  40009007: '當配送方式為直店配時，售價不可超過NT$20,000', // Price cannot be greater than CVS' limitation NT$20,000
  40009008: '該子站編號不存在或者輸入錯誤', // Missing or bad sub station ID
  40009009: '無法取得影音相關檔案', // Cannot fetch the provided media resource(s)
  40009010: '市價不可為0', // Manufacturer's suggested retail price cannot be 0
  40009011: '售價不可為0', // Price cannot be 0
  40009012: '成本不可為0', // Cost cannot be 0
  40009013: '售價需低於市價', // Price cannot be greater than Manufacturer's suggested retail price
  40009014: '成本需低於市價', // Cost cannot be greater than Manufacturer's suggested retail price
  40009015: '成本需高於售價', // Cost cannot be greater than price
  40009016: '市價不可為0', // Manufacturer's suggested retail price cannot be empty when the review status isn't composing
  40009017: '售價不可為0', // Price cannot be empty when the review status isn't composing and the type is newListing
  40009018: '成本不可為0', // Cost cannot be empty when the review status isn't composing
  40009019: '圖片或影片順序不可重複', // Duplicated proposal product media order
  40009020: '商品主圖需上滿兩張', // Insufficient proposal product main image
  40009021: '主圖尺寸需為 1000x1000px 或以上', // The main image dimension should be a square and greater than 1000x1000 pixels
  40009022: '圖片尺寸需為 400x400px 或以上', // The image dimension should be a square and greater than 400x400 pixels
  40009023: '請上傳第一組商品圖片', // The first proposal product model must have images when the review status isn't composing
  40009024: '請上傳各組商品圖片或勾選共用同組商品圖', // Seems not sharing images between models, please provide images for each model
  40009025: '商品詳情內容有誤', // Invalid iframe URL in the proposal copy HTML
  40009026: '不接受外站圖片，請重新上傳圖片', // Invalid image URL (non-yahoo) in the proposal copy HTML
  40009027: '賣場顯示順序填寫有誤', // Invalid listing display order
  40009028: '商品詳情內容有誤', // Invalid content in the proposal copy HTML
  40009029: '類別有誤，請重新選擇', // Mismatch category ID
  40009030: '類別有誤，請重新選擇', // Invalid categoryItem ID
  40009035: '保固期限不可為空', // Product warranty cannot be empty when the review status isn't composing
  40009036: '保固範圍不可為空', // Product warranty scope cannot be empty when the review status isn't composing and warranty period isn't `無保固`
  40009037: '保固來源不可為空', // Invalid product warranty handler, empty or `none` when the review status isn't composing or warranty period isn't `無保固`
  40009038: '商品圖片或影片有誤，請重新上傳', // Invalid media URL in the proposal product models
  40009039: '無效的國際條碼', // Invalid barcode
  40009040: '進倉用國際條碼已存在，請選擇由系統產生', // Duplicated warehouse barcode
  40009041: '商品無法指定為需安裝', // Cannot designate the product as an install required item
  40009042: '商品無法指定為大材積或附屬贈品', // Cannot designate the product as a large volume item's gift
  40009043: '審核期限需為提案日＋3~15天', // Proposal expired time must within +3 and +15 days
  40009044: '請選擇賣場級別', // Product content rating cannot be empty when the review status isn't composing
  40009045: '無效的賣場級別', // Invalid product content rating
  40009046: '無效的安全庫存量', // Invalid product safe stock quantity
  40009047: '商品材積不可為空', // Product length cannot be empty when the review status isn't composing
  40009048: '商品材積不可為空', // Product width cannot be empty when the review status isn't composing
  40009049: '商品材積不可為空', // Product height cannot be empty when the review status isn't composing
  40009050: '商品重量不可為空', // Product weight cannot be empty when the review status isn't composing
  40009051: '商品長+寬+高需小於150cm', // Product length + width + height must be less than 150 cm
  40009052: '商品重量需低於20000g', // Product weight must be less than 20000 gram
  40009053: '無效的保存期限', // Invalid product preserve days
  40009054: '商品無法設為即期品', // Product cannot be a expiring item
  40009055: '商品名稱有誤', // Invalid product name, might be longer than 45 words or contains invalid character
  40009056: '最小包裝數有誤', // Invalid product minimum packing count
  40009057: '請選擇顯示設定', // Product display mode cannot be empty when the review status isn't composing
  40009058: '不可填寫遊戲軟體情節', // Product game contents must be empty
  40009059: '請填寫商品規格', // Product structure data attribute cluster ID cannot be empty when the review status isn't composing
  40009060: '商品規格不可重複', // Duplicated product specification
  40009061: '商品屬性不可重複', // Duplicated product attribute
  40009062: '屬性與規格不可重複', // Duplicate attributes and specifications
  40009063: '提案為無屬性時屬性必須為空', // Proposal model specification must be empty when there is no attribute in the proposal
  40009064: '提案為無屬性時屬性顯示名稱必須為空', // Proposal model display name must be empty when there is no attribute in the proposal
  40009065: '提案中各個第一層屬性名稱必須相同', // Proposal model specification name must be equal to each other
  40009066: '非雙層屬性提案時第二層屬性必須為空', // Proposal item specification must be empty when there aren't 2 attributes in the proposal
  40009067: '非雙層屬性提案時第二層屬性顯示名稱必須為空', // Proposal item display name must be empty when there aren't 2 attributes in the proposal
  40009068: '提案中各個第二層屬性名稱必須相同', // Proposal item specification name must be equal between models
  40009069: '備貨數量填寫有誤', // Invalid proposal item stock
  40009070: '不可設定進倉用國際條碼', // Proposal item warehouse barcode must be empty
  40009071: '不可設定實際國際條碼', // Proposal item barcode must be empty
  40009072: '非無屬性提案時屬性不可為空', // Proposal model specification cannot be empty when there isn't no attribute in the proposal
  40009073: '第一層屬性值只能有一個值，且必須為該規格選項內的值', // Proposal model specification values must have only one value and pre-defined in structured data
  40009074: '雙層屬性提案的第二層屬性不可為空', // Proposal item specification cannot be empty when there are 2 attributes in the proposal
  40009075: '第二層屬性值只能有一個值，且必須為該規格選項內的值', // Proposal item specification values must have only one value, be equal between models and pre-defined in structured data
  40009076: '提案狀態不為草稿時商品屬性不可為空', // Proposal models cannot be empty when the review status isn't composing
  40009077: '請選擇類別及規格表', // Category item ID cannot be empty when the review status isn't composing
  40009078: '中文化網址不可為空', // Listing URL cannot be empty when the review status isn't composing
  40009079: '名稱需包含 `(即期品)`', // Product name must start with `(即期品)`
  40009080: '中文化網址有誤', // Listing URL only allow Chinese, English, numeric and dash (`-`)
  40009081: '商品特色每條不可超過15個字', // Invalid product short description, might be longer than 15 words or contains invalid character
  40009082: '商品特色不可為空', // Product short description must have at least one is not empty when the review status isn't composing
  40009083: '配送方式不可為空', // Listing delivery type cannot be empty when the review status isn't composing
  40009084: '當交貨期限為預購行商品時，預購型商品預定出貨日不可為空', // Listing pre-order expected ship date cannot be empty when delivery type is pre-order
  40009085: '請設定客約送貨日日期', // Listing customized order ship date after placed cannot be empty when delivery type is customized
  40009086: '預購型商品日期設定有誤', // Listing pre-order expected ship date must within +5 and +45 days
  40009087: '僅單層屬性才可設定共用同組商品圖', // Cannot sharing media between models for the proposal which isn't with 1 layer attribute
  40009088: '開始時間不可晚於結束時間', // Listing on shelved time cannot be greater than off shelved time
  40009089: '商品詳情不可為空', // Product copy cannot be empty when the review status isn't composing
  40009090: '超取限購數量必須小於20000除以售價', // Listing CVS purchase quantity limit must less than 20000 / price
  40009091: '不允許輸入超取限購數量', // Listing CVS purchase quantity limit must be empty
  40009092: '不可設為廢四機商品', // Cannot designate the product as a recyclable item
  40009093: '不可設為買斷商品', // Cannot designate the product as an outright purchased item
  40009094: '您尚未簽約該配送方式', // The supplier hasn't be granted the ship type permission
  40009095: '配送方式有誤', // Invalid delivery type
  40009096: '選擇的規格不屬於目前規格表的分類，或是規格表不存在', // Invalid structure data attribute cluster ID
  40009097: '僅需設定第一組商品圖片或移除共用同組商品圖設定', // Only the first model can assign images when sharing media between models
  40009098: '影片設定有誤', // Only the first model can assign videos when sharing media between models
  40009100: '折抵工具有誤', // Unallowed discount tool
  40009101: '折抵工具有誤', // Unallowed discount target member
  40009102: '折抵工具有誤', // Unallowed discount site
  40009103: '折抵工具有誤', // Unallowed discount activity
  40009104: 'Cannot PUT the proposal which review status isn\'t composing and draft', // Cannot PUT the proposal which review status isn't composing and draft
  40009105: '網址有誤或不存在', // Cannot create a proposal with review status not in `composing`, `draft` and `pendingReview`
  40009106: '保固期限不可為空', // Cannot create a non-composing proposal with empty warranty period
  40009107: '保固來源不可為空', // Proposal applicant cannot be empty when the review status isn't composing
  40009108: '圖片或影片設定有誤', // The order number must be sequential when the review status isn't composing
  40009109: '配送方式選擇有誤', // The sub station doesn't support the delivery type
  40009110: '配送方式選擇有誤', // Invalid ship type ID
  40009111: '商品名稱不可為空', // Product name cannot be empty when the review status isn't composing
  40009112: '屬性或規格不可為空', // Product attribute value cannot be empty
  40009113: '屬性或規格長度有誤', // Product attribute value's length does not meet the constraints
  40009114: '自訂之屬性或規格過多', // Too many customized product attribute values
  40009115: '所有必填的規格皆須填寫', // Missing required product attribute
  40009116: '屬性或規格名稱不可重複', // Product attributes values are duplicated
  40009117: '屬性或規格過多', // Too many product attribute values
  40009118: '屬性或規格不符合所選之規格表', // Mismatch proposal product 'models' and 'specs' structure
  40009119: '圖片順序不可為空', // The image order cannot be empty
  40009120: '遊戲軟體情節重複', // Duplicated game contents
  40009121: '無效的遊戲軟體情節', // Unallowed game contents
  40009122: '需勾選大材積', // Invalid product is large volume
  40009123: '改善或建議必須為空', // Proposal suggestion must be empty when the review status is `composing`, `draft` or `pendingReview`
  40009124: '屬性或規格名稱重複', // Duplicated display name
  [API_ERROR_CODE.INVALID_LISTING_ID]: '無效的賣場編號', // Invalid listing ID
  40009128: '無效的賣場詳情', // Invalid listing copy
  40009131: '影片不存在', // Video does not exist
  40009132: '商品長度、寬度或高度必須小於等於他的限制', // Product length, width or height must be less than or equals to its limitation
  40009133: '商品編號不屬於這個賣場', // The SKU doesn’t belong to the listing
  40009134: '賣場提案裡有重複的商品編號', // Duplicated SKU in the proposal listing models, additionalPurchases, complimentaries or selectComplimentaries
  40009135: '如果要共用媒體，第一個商品編號需要對應到賣場', // The first model SKU must correspond to the listing if you share the media between models
  40009136: '圖片尺寸必須為 1000、400、250、135 或 80', // The image dimension must be 1000, 400, 250, 135 or 80
  40009137: '圖片必須為正方形且大於等於規定的大小', // The image must be square and the dimension must greater than or equal to the specified pixels
  40009138: '圖片連結不屬於這個賣場', // The image URL doesn’t belong to the listing
  40009139: '無法對應原始圖片寬度', // The width doesn’t match the original image
  40009140: '當賣場提案屬性項目用於賣場，他們不能有圖片或影片', // The proposal listing images/videos must be empty when there are models in the listing
  40009141: '無屬性賣場的賣場提案不能有屬性項目', // The proposal listing models must be empty when there is no model in the listing
  40009142: '商品編號無法直接修改', // The SKU belongs to a complimentary group, cannot be adjusted directly
  40009143: '進倉的商品名稱必須少於 50 字', // Product name for warehouse entry must be less than 50 words
  40009144: '賣場的商品屬性項目圖片需要同步', // Product images must be synchronized when there are models in the listing
  40009145: '重複倉庫商品名稱', // Duplicated warehouse product name
  40009146: '無效之NCC認証碼', // Invalid ncc format
  40009149: '無效商品編號', // Invalid product ID
  40009150: '無效商品編號', // The sku's supplier ID is different from the listing's
  40009179: '賣場之分類有誤，請聯繫您的業務窗口', // The listing's category does not exist
  40009182: '商品規格不存在', // The structure data attribute cluster ID inconsistent in listing
  40009188: SHIP_TYPE_ERROR.NOT_AVAILABLE_STORE_DELIVERY,
  40009203: '有屬性贈品的虛商品商品編號不存在賣場', // The SKU not in listing complimentaries
  40009204: '贈品商品成本不為 0', // Invalid gift cost
  40009205: '贈品商品 category 不為贈品類別', // Invalid gift category
  40009206: '不可同時驗證贈品及加價購商品', // Cannot validate gift and additional purchase simultaneously
  40009207: '贈品必選數量錯誤', // Invalid gift select minimum quantity
  40009208: '贈品名稱超過限制', // Invalid gift specification selected value length
  40009209: '配件總數超過限制', // Invalid listing attribute count
  40009210: '加價購商品成本錯誤', // Invalid additional purchase cost
  40009211: '加價購商品售價錯誤', // Invalid additional purchase price
  40009212: '產品狀態錯誤', // Invalid product warranty productStatus
  40009215: '批次提案回檔時間需至少在執行時間之後 15 分鐘', // Batch proposal revert time should be at least 15 minutes after execute time
  40009216: '批次提案執行時間需在 +2 小時及 +30 天之內', // Batch proposal execute time must within +2 hours and +30 days
  40009217: '批次提案回檔時間需在 +3 小時及 +60 天之內', // Batch proposal revert time must within +3 hours and +60 days
  40009225: '該提案狀態下商品品牌不可為空', // Brand ID cannot be empty when the review status isn't composing
  40009226: '填寫的商品品牌未在可選的品牌選項當中，請重新選擇', // Brand ID must be pre-defined in brand data
  40009229: '無效之「BSMI商品檢驗字號」', // Invalid BSMI code
  40009231: '無效之TD識別碼', // Invalid TD code
  40309000: '您無該子站之權限', // The supplier hasn't signed the sub station contract
  [API_ERROR_CODE.NO_PERMISSION]: '您無存取權限', // No permission
  41009001: '無效的子站類別', // The category item no longer exists
  42209000: '提案類型僅支援newListing及newProduct', // Supports POST/PUT newListing and newProduct proposal type only currently
  42209001: '審核狀態僅支援composing，draft及pendingReview', // Supports POST/PUT composing, draft and pendingReview proposal review status only currently
  42209002: '非法審核狀態', // Invalid state flow of proposal review status
  42209006: '批次提案無法立即回檔，請確認是否回檔已正在進行中', // Batch proposal is not revertible
  42900001: '可修改次數已超過上限', // Reach the maximum number of modification times
  40411000: '此賣場不存在', // Listing not found
  ...FRONT_END_DEFINED_ERROR_MAPPING
}

export const ALERT_TYPE_MAP = {
  [SUCCESS]: 'Success',
  [ERROR]: 'Error',
  [WARNING]: 'Warning',
  [INFO]: 'Info'
}

export const ERROR_CODE = {
  0: '欄位驗證失敗'
}

export const DEFAULT_PAGINATION = {
  perPage: 20,
  sliceBy: 20,
  currentPage: 1,
  totalPage: 1,
  nextOffset: '',
  resultsTotal: 0
}

// 熱銷排行 預設天數 30天
export const DEFAULT_BESTSELLER_TERM = 30

// 滯銷天數 預設30天
export const DEFAULT_UNSALABLE_THRESHOLD = 30

export const SALE_FILTER_TYPE_MAP = {
  AMOUNT: {
    type: 'AMOUNT',
    key: 'amount',
    text: '訂購金額'
  },
  COUNT: {
    type: 'COUNT',
    key: 'count',
    text: '訂購量'
  }
}

export const BESTSELLER_FILTER_TYPE_MAP = {
  AMOUNT: {
    type: 'AMOUNT',
    key: 'soldAmount',
    text: '訂購金額'
  },
  QUANTITY: {
    type: 'QUANTITY',
    key: 'soldQuantity',
    text: '訂購量'
  },
  PAGE_VIEW: {
    type: 'PAGE_VIEW',
    key: 'pageView',
    text: '瀏覽量'
  },
  CONVERSION_RATE: {
    type: 'CONVERSION_RATE',
    key: 'conversionRate',
    text: '轉換率'
  }
}

export const SELLER_BESTSELLER_FILTER_TYPE_MAP = {
  ...BESTSELLER_FILTER_TYPE_MAP,
  UNIQUE_USER: {
    type: 'UNIQUE_USER',
    key: 'uniqueUser',
    text: '訪客數'
  }
}

export const SALE_STAT_KEY_MAP = {
  newOrderCount: {
    text: '訂單成立數',
    tooltip: '查詢區間內買家訂購成功之訂單總數'
  },
  canceledOrderCount: {
    text: '訂單取消數',
    tooltip: '查詢區間之訂單取消總數'
  },
  refundApplicationCount: {
    text: '退貨申請數',
    tooltip: '查詢區間之申請退貨訂單數'
  },
  periodOrderSubtotal: {
    text: '區間訂單數小計',
    tooltip: '=訂單成立數 - 訂單取消數 - 退貨申請數'
  },
  newOrderAmount: {
    text: '訂單成立金額',
    tooltip: '查詢區間內買家訂購成功訂單之訂購成本總額'
  },
  canceledOrderAmount: {
    text: '訂單取消金額',
    tooltip: '查詢區間內訂單取消之訂購成本總額'
  },
  refundApplicationAmount: {
    text: '退貨申請金額',
    tooltip: '查詢區間內申請退貨之訂購成本總額'
  },
  periodOrderAmountSubtotal: {
    text: '區間訂單金額小計',
    tooltip: '=訂單成立金額 - 訂單取消金額 - 退貨申請金額'
  }
}

export const BRAND_STAT_KEY_MAP = {
  orderYoy: {
    text: '訂單成長數 YoY',
    tooltip: '此品牌之訂單年度成長率(與去年同期進行比較)'
  },
  salesYoy: {
    text: '營業額成長數 YoY',
    tooltip: '此品牌之營業額年度成長率(與去年同期進行比較)'
  },
  averageOrderValue: {
    text: '平均客單價',
    tooltip: '此品牌在資料統計區間之買家平均購買單價'
  },
  purchaseFrequency: {
    text: '平均購買頻次',
    tooltip: '此品牌在資料統計區間之買家平均購買次數'
  }
}

export const BRAND_STAT_KEYS = Object.keys(BRAND_STAT_KEY_MAP)

export const WAREHOUSE_STAT_KEY_MAP = {
  inventories: {
    flagName: 'features.sp_invent._enable',
    text: '在庫品項數',
    tooltip: '目前在庫之品項數',
    url: ''
  },
  totalDeliveryQty: {
    flagName: 'features.sp_tDeliQty._enable',
    text: '本月累積出貨量',
    tooltip: '進倉商品本月(預設為當月 1 日至當日前一天)累積出貨量',
    url: ''
  },
  expiringItems: {
    flagName: 'features.sp_expItems._enable',
    text: '效期警示品項數',
    tooltip: '即將到期之品項(商品)數; 點擊品項數可顯示效期警示商品清單',
    url: '/warehouse/expiringItems',
    i13nModel: {
      label: i13nConf.expiringItems.subType
    }
  },
  unsalableItems: {
    flagName: 'features.sp_unsaItems._enable',
    text: '滯銷品項數',
    tooltip: `連續 ${DEFAULT_UNSALABLE_THRESHOLD} 日以上銷量＝0 ; 點擊品項數可顯示滯銷商品清單`,
    url: '/warehouse/unsalableItems',
    i13nModel: {
      label: i13nConf.unsalableItems.subType
    }
  },
  totalReceivedQty: {
    text: '本月累積進貨量',
    tooltip: '進倉商品本月(預設為當月 1 日至當日前一天)累積進貨量',
    url: ''
  },
  totalAmount: {
    text: '目前庫存金額',
    tooltip: '進倉商品在倉庫的總計庫存金額(訂購成本X商品數量)',
    url: ''
  },
  totalVolume: {
    text: '目前庫存材積',
    tooltip: '進倉商品在倉庫的總計材積(長X寬X高/27000)',
    url: '',
    format: '0,0.00'
  }
}

export const WAREHOUSE_STAT_KEYS = Object.keys(WAREHOUSE_STAT_KEY_MAP)

export const DEMOGRAPHICS_REPORT_KEY_MAP = {
  buyersAge: {
    text: '年齡',
    tooltip: ''
  },
  buyersGender: {
    text: '性別',
    tooltip: ''
  }
}

export const DEMOGRAPHICS_REPORT_KEYS = Object.keys(DEMOGRAPHICS_REPORT_KEY_MAP)

export const EXPORT_TEMPLATE_SETTING = {
  unsalableItems: {
    indexKey: '_index',
    sheetName: '{{ threshold }}天滯銷品項清單',
    headers: { _index: '項次', productId: '商品序號', name: '商品名稱', unsalableDays: '滯銷天數', volume: '庫存' },
    fileName: 'unsalableItemsBy{{ threshold }}_{{ nowDate.format("YYYYMMDDhhmmss") }}',
    bookType: 'xlsx'
  },
  expiringItems: {
    indexKey: '_index',
    sheetName: '效期警示品項清單',
    headers: { _index: '項次', productId: '商品序號', name: '商品名稱', expiryDate: '有效期限/到期日', lastSaleableDate: '最後可銷售日期', availableDays: '允售天數', volume: '庫存' },
    fileName: 'expiringItems_{{ nowDate.format("YYYYMMDDhhmmss") }}',
    bookType: 'xlsx'
  },
  bestSelling: {
    indexKey: 'ranking',
    sheetName: '{{ startDate.format("YYYYMMDD") }}-{{ endDate.format("YYYYMMDD") }}', // 起-迄, ex: 20180523-20180621
    headers: {
      ranking: '排名',
      listingId: '賣場編號',
      name: '賣場名稱',
      soldAmount: '訂購金額',
      soldQuantity: '訂購量',
      pageView: '瀏覽量',
      conversionRate: '轉換率(%)',
      availableQuantity: '可銷售量',
      price: '目前售價'
    },
    fileName: 'bestSellingBy{{ sortType }}{{ term }}Days_{{ nowDate.format("YYYYMMDDHHmmss") }}{{ stockAndActive }}',
    bookType: 'xlsx'
  },
  seller: {
    bestSelling: {
      indexKey: 'ranking',
      sheetName: '{{ startDate.format("YYYYMMDD") }}-{{ endDate.format("YYYYMMDD") }}', // 起-迄, ex: 20180523-20180621
      headers: {
        ranking: '排名',
        listingId: '賣場編號',
        name: '賣場名稱',
        soldAmount: '訂購金額',
        soldQuantity: '訂購量',
        pageView: '瀏覽量',
        conversionRate: '轉換率(%)',
        uniqueUser: '訪客數',
        availableQuantity: '可銷售量',
        price: '目前售價'
      },
      fileName: 'bestSellingBy{{ sortType }}{{ term }}Days_{{ nowDate.format("YYYYMMDDHHmmss") }}{{ stockAndActive }}',
      bookType: 'xlsx'
    }
  }
}

export const DATE_TYPE = {
  YEAR: 'year',
  MONTH: 'month',
  DAY: 'day'
}

export const DATE_TYPE_KEY_MAP = {
  [DATE_TYPE.YEAR]: '年',
  [DATE_TYPE.MONTH]: '月',
  [DATE_TYPE.DAY]: '日'
}

export const DATE_TYPE_SIZE = {
  [DATE_TYPE.YEAR]: 365,
  [DATE_TYPE.MONTH]: 30,
  [DATE_TYPE.DAY]: 1
}

export const EMPTY_VALUE = '--'

export const OTHER_BRAND_ID = '41171558'
